import { useEffect, useState } from 'react';

interface OTPTimerProps {
  openOTPModal: boolean;
}

interface OTPTimerHook {
  timerNewCode: string;
  startTimerCode: () => void;
}

export const useOTPTimer = (props: OTPTimerProps): OTPTimerHook => {
  const { openOTPModal } = props;

  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | number | null>(null);
  const [timerNewCode, setTimerNewCode] = useState<string>('1:00');

  const startTimerCode = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }

    if (openOTPModal) {
      let remainingTime = 60;
      setTimerNewCode('1:00');

      const intervalId = setInterval(() => {
        remainingTime -= 1;

        const minutes = Math.floor(remainingTime / 60);
        const seconds = remainingTime % 60;
        setTimerNewCode(`${minutes}:${seconds < 10 ? '0' : ''}${seconds}`);

        if (remainingTime <= 0) {
          clearInterval(intervalId);
          setIntervalId(null);
          setTimerNewCode('');
        }
      }, 1000);

      setIntervalId(intervalId);
    }
  };

  useEffect(() => {
    startTimerCode();

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [openOTPModal]);

  return {
    timerNewCode,
    startTimerCode,
  };
};
